import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { get, includes } from "lodash"
import { MODAL_CANVAS_ID } from "components/atoms/chart/logic/chartConfig"
import { FOREIGN_STOCK, SECURITY_TYPE } from "config/const"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"

const SpChartPriceDetail = () => {
  const symbolDetailSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].symbolDetail
  const symbolDetail = useSelector(symbolDetailSelector)

  const labelVisible = useMemo(() => {
    const targetSecurityType = get(symbolDetail, "SecurityType")
    return (
      includes(FOREIGN_STOCK, targetSecurityType) ||
      SECURITY_TYPE.Equity.id === targetSecurityType
    )
  }, [symbolDetail])

  const NumberOfDecimals = useMemo(() => {
    return get(symbolDetail, "NumberOfDecimals", 0)
  }, [symbolDetail])

  const isChanged = useMemo(() => {
    return Formatter.upDown(get(symbolDetail, "ChangedRatio", null))
  }, [symbolDetail])

  return (
    <div className="sp-price-detail">
      <div className="sp-price-detail-row">
        {labelVisible && (
          <div className="sp-price-detail-items symbol-code-label">
            {Formatter.symbol(symbolDetail)}
          </div>
        )}
        <div className="sp-price-detail-items">
          {get(symbolDetail, "SymbolNameS") || get(symbolDetail, "SymbolName")}
        </div>
        <div className="sp-price-detail-items time-col">
          {Formatter.date(get(symbolDetail, "PriceTime"), "MM/DD HH:mm")}
        </div>
      </div>
      <div className="sp-price-detail-row">
        <div className="sp-price-detail-items price-detail-currency-value-group">
          <div className="price-detail-currency-value-items price-detail-currency-value">
            {Formatter.number(
              get(symbolDetail, "Price", null),
              NumberOfDecimals
            )}
          </div>
          <div className="price-detail-currency-value-items">
            <i className={ClassNames("material-icons", isChanged)}>
              {`arrow_${isChanged === "equal" ? "for" : isChanged}ward`}
            </i>
          </div>
        </div>
        <div
          className={ClassNames(
            "sp-price-detail-items",
            Formatter.upDown(get(symbolDetail, "ChangedPrice"))
          )}
        >
          {Formatter.number(
            get(symbolDetail, "ChangedPrice", null),
            NumberOfDecimals,
            "floor",
            true
          )}
        </div>
        <div className="sp-price-detail-items">
          (
          <span
            className={ClassNames(
              Formatter.upDown(get(symbolDetail, "ChangedRatio"))
            )}
          >
            {Formatter.number(
              get(symbolDetail, "ChangedRatio", null),
              2,
              "floor",
              true
            )}
          </span>
          <span className="unit">%</span>)
        </div>
      </div>
    </div>
  )
}

export default SpChartPriceDetail
